module.exports = __webpack_public_path__ + "static/media/road-icon.01d990c6.svg";